import { FC } from 'react';
import { TwoFaSectionTitle } from '../../../shared/TwoFaSectionTitle';
import { TwoFaSectionButtonsWrapper } from '../../../shared/TwoFaSectionButtonsWrapper';
import { TwoFaSectionDescription } from '../../../shared/TwoFaSectionDescription';
import { ButtonBase } from '../../../../../ButtonBase/ButtonBase';
import { DeleteTwoFaOnContinue, DeleteTwoFaOnDelete } from '../../utils/types';
import { css } from '@bts-web/utils-style-engine';
import { TwoFaContentWrap } from '../../../shared/TwoFaContentWrap';
import { TwoFaScreenTranslations } from '../../utils/get2faTranslations';

const ResetTwoFaInitialScreen: FC<{
  onDismiss: DeleteTwoFaOnDelete;
  translations: TwoFaScreenTranslations;
  onContinue: DeleteTwoFaOnContinue;
  dismissLoading: boolean;
}> = ({ onDismiss, onContinue, dismissLoading, translations }) => {
  return (
    <>
      <TwoFaContentWrap>
        <TwoFaSectionTitle title={translations.reset2faAreYouSure} />
        <TwoFaSectionDescription
          textContent={translations.reset2faDescription}
        />
      </TwoFaContentWrap>
      <TwoFaSectionButtonsWrapper>
        <ButtonBase
          isLoading={dismissLoading}
          onClick={onContinue}
          visual="primary"
          size="large"
          fullWidth
          disabled={dismissLoading}
        >
          {translations.reset2faTitle}
        </ButtonBase>

        <ButtonBase
          disabled={dismissLoading}
          isLoading={dismissLoading}
          visual="ghost"
          onClick={onDismiss}
          className={css({
            textDecoration: 'underline',
          })}
        >
          {translations.reset2faSkip}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { ResetTwoFaInitialScreen };
